<cm-menu></cm-menu>
<div class="not-found">
  <storybook-error-full [title]="'404'" [subTitle]="'Page not found'" />
</div>
